import { axiosInstance } from '../request';
export const getModels = async () => {
    const response = await axiosInstance.get('/api/v1/catalogs/models');
    return response.data.sort((a, b) => a.localeCompare(b));
};
//# sourceMappingURL=catalogs.api.js.map